module.exports = __webpack_public_path__ + "static/img/Solutionimg2.4251c020.jpg";